import { createRoot } from "react-dom/client";
import App from "./App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider } from "antd";
import { themeProps } from "@alphascriptsolutions/client-core";

const rootElement: HTMLElement | null = document.getElementById("placeholder");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <ConfigProvider theme={{
      ...themeProps,
      token: {
        ...themeProps.token,
        fontSize: 13,
      }
    }}>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </ConfigProvider>
  );
});
